import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT } from "./actions";

export const initialState = {
  user: null,
  loading: false,
  error: null,
  sessionExpired: true,
  system_id: null,
};

export default function loginReducer(state, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return { ...state, loading: true, error: null };
    case LOGIN_SUCCESS:
      return { ...state, loading: false, user: action.payload, sessionExpired: false };
    case LOGIN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case LOGOUT:
      return { ...state, user: null, sessionExpired: true };
    default:
      return state;
  }
}
